import { z as e } from "zod";
//#region src/proxy-message/assessment-launch.ts
var t = e.union([
	e.literal("canvas"),
	e.literal("moodle"),
	e.literal("BlackboardLearn"),
	e.literal("desire2learn"),
	e.literal("verity")
]), n = e.string().trim().min(1), r = e.object({
	kind: e.literal("verity"),
	assessmentId: e.number().int().positive()
}).strict(), i = e.object({
	kind: e.literal("lms"),
	lms: t,
	hostname: n,
	courseId: n,
	assessmentId: n
}).strict(), a = e.discriminatedUnion("kind", [r, i]), o = e.object({
	lms: t,
	hostname: n,
	lmsProvidedAssessmentId: n,
	lmsProvidedCourseId: n
});
function s(e, t) {
	return e.kind === t.kind && (e.kind === "verity" && t.kind === "verity" || e.kind === "lms" && t.kind === "lms" && e.lms === t.lms && e.hostname === t.hostname && e.courseId === t.courseId) && e.assessmentId === t.assessmentId;
}
//#endregion
export { o as StandaloneAssessmentInfoSchema, a as assessmentLaunchDescriptorSchema, s as assessmentLaunchDescriptorsEqual, i as lmsAssessmentLaunchDescriptorSchema, r as verityAssessmentLaunchDescriptorSchema };
